import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { initAnalytics, resolveAnalytics } from '@easydent/shared-ui';
import { useAuthStore } from '@/stores/authStore';
import AppCookieBanner from '@/components/AppCookieBanner';
import Layout from '@/components/Layout';
import LoginPage from '@/pages/LoginPage';
import DemoPage from '@/pages/DemoPage';
import DashboardPage from '@/pages/DashboardPage';
import CreativesPage from '@/pages/CreativesPage';
import CampaignsPage from '@/pages/CampaignsPage';
import AccountPage from '@/pages/AccountPage';

const RequireSupplier: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Layout>{children}</Layout>;
};

const App: React.FC = () => {
  // Consent-gated analytics. Stays off until this app has a website id AND the visitor consents.
  useEffect(() => {
    initAnalytics(resolveAnalytics('supplier'));
  }, []);

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/" element={<RequireSupplier><DashboardPage /></RequireSupplier>} />
        <Route path="/creatives" element={<RequireSupplier><CreativesPage /></RequireSupplier>} />
        <Route path="/campaigns" element={<RequireSupplier><CampaignsPage /></RequireSupplier>} />
        <Route path="/account" element={<RequireSupplier><AccountPage /></RequireSupplier>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* Rendered here, not per page — a layout element belongs to the layout, and the login and
          demo pages sit outside Layout entirely. */}
      <AppCookieBanner />
    </>
  );
};

export default App;
